import autoBind from 'react-autobind/src/autoBind';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Entities, patch, Projection } from 'src/common';
import { addNotification } from 'src/actions/notifications';
import BusRequestArchiveForm from 'src/components/administration/bus-request/components/bus-request-archive-form';

class BusRequestArchiveModalAdmin extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { t, busRequest } = this.props;

        return (
            <BusRequestArchiveForm
                t={t}
                busRequest={busRequest}
                onSubmit={this.handleSubmit}
                ref={ref => (this.childForm = ref)}
            />
        );
    }

    async handleSubmit(formData) {
        const { busRequest, handleClose, t, selectedCompany } = this.props;
        const data = {
            id: busRequest.id,
            isArchived: true,
        };

        this.props
            .patch(
                data,
                Entities.BUS_REQUESTS,
                this.props.selectedCompany,
                Projection.FULL,
                undefined,
                'archiveBusRequest',
            )
            .then(() => {
                this.props.addNotification(
                    t('common_phrases.success'),
                    t('bus_requests.archive_success'),
                    'success',
                    'tr',
                );
                this.props.findOwnedByBusfinderIntegrationBusRequests(this.props.filter);
            });

        handleClose();
    }
}

export default connect(
    () => {
        return {};
    },
    {
        patch,
        addNotification,
    },
    null,
    { withRef: true },
)(BusRequestArchiveModalAdmin);
